import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    replyableType: String,
    replyableId: String,
  };

  declare replyableTypeValue: string;
  declare replyableIdValue: string;

  scrollToReplyable() {
    // Build the DOM ID based on the replyable type
    let domId: string;

    if (this.replyableTypeValue === "ConversationMessage") {
      domId = `conversation_message_${this.replyableIdValue}`;
    } else if (this.replyableTypeValue === "Placements::Plan") {
      domId = `message_placements_plan_${this.replyableIdValue}`;
      console.error("not implemented yet");
    } else if (this.replyableTypeValue === "Placements::Placement") {
      domId = `placements_placement_${this.replyableIdValue}_card`;
    } else {
      console.warn(`Unknown replyable type: ${this.replyableTypeValue}`);
      return;
    }

    const targetElement = document.getElementById(domId);

    if (!targetElement) {
      console.warn(`Element with ID ${domId} not found`);
      return;
    }

    // Scroll to the element with smooth behavior
    targetElement.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });

    // Add highlight effect
    this.highlightElement(targetElement);
  }

  private currentHighlightedElement: HTMLElement | null = null;
  private removeHighlightListener: ((event: MouseEvent) => void) | null = null;

  private highlightElement(element: HTMLElement) {
    // Remove any existing highlights from other elements
    document.querySelectorAll(".replyable-highlighted").forEach((el) => {
      el.classList.remove("replyable-highlighted");
    });

    // Remove previous click listener if exists
    if (this.removeHighlightListener) {
      document.removeEventListener("click", this.removeHighlightListener);
    }

    // Add highlight with transition
    element.classList.add("replyable-highlighted");
    this.currentHighlightedElement = element;

    // Listen for clicks elsewhere to remove highlight
    this.removeHighlightListener = (event: MouseEvent) => {
      const clickedElement = event.target as Node;

      // Check if clicked on the highlighted element or a replyable preview trigger
      const isHighlightedElement = element.contains(clickedElement);
      const isReplyablePreview = (clickedElement as Element).closest(
        '[data-controller*="scroll-to-replyable"]',
      );

      if (!isHighlightedElement && !isReplyablePreview) {
        element.classList.remove("replyable-highlighted");
        if (this.removeHighlightListener) {
          document.removeEventListener("click", this.removeHighlightListener);
          this.removeHighlightListener = null;
        }
        this.currentHighlightedElement = null;
      }
    };

    // Add click listener after a small delay to avoid immediate removal
    setTimeout(() => {
      if (this.removeHighlightListener) {
        document.addEventListener("click", this.removeHighlightListener);
      }
    }, 100);
  }
}
